import {useServiceApiMutation} from 'stores/hooks/query';
import utils from 'helpers/utils';
import constants from 'helpers/constants';

const path = utils.servicePath(import.meta.url);

export function useAnalyseAdvice (mutationOptions = {}) {
  return useServiceApiMutation(path, 'post', {}, {
    overridePath: 'analyse/advice',
    overrideDataType: constants.dataTypes.other,
    ...mutationOptions
  });
}
